import { HashRouter as Router, Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Home from './pages/Home'
import AboutUs from './pages/AboutUs'
import Events from './pages/Events'
import Contact from './pages/Contact'
import ForPrinciples from './pages/ForPrinciples'
import ForParents from './pages/ForParents'
import ForPastors from './pages/ForPastors'
import ForYouth from './pages/ForYouth'
import Resources from './pages/Resources'
import './App.css'

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />

          <Route path="/for-principles" element={<ForPrinciples />} />
          <Route path="/for-parents" element={<ForParents />} />
          <Route path="/for-pastors" element={<ForPastors />} />
          <Route path="/for-youth" element={<ForYouth />} />
          <Route
            path="/events"
            element={
              <Events
                apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
                calendarId={process.env.REACT_APP_GOOGLE_CALENDAR_ID}
                secondaryEndpoint={
                  process.env.REACT_APP_SECONDARY_CALENDAR_ENDPOINT || ''
                }
                displayTimeZone="Pacific/Auckland"
                maxResults={12}
                locale="en-NZ"
              />
            }
          />
          <Route path="/contact" element={<Contact />} />
          <Route path="/resources" element={<Resources />} />
        </Routes>
      </div>
    </Router>
  )
}

export default App
